/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1SweepBalanceState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_SWEEP_BALANCE_STATE_ENTITY_NAME = 'ixc.portfolio.v1.SweepBalance';
export const ixcPortfolioV1SweepBalanceStateEntity = new schema.Entity<IxcPortfolioV1SweepBalanceState>(IXC_PORTFOLIO_V1_SWEEP_BALANCE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1SweepBalanceState) => `${entity.accountId}-${entity.assetId}` });

